const {
    FUNDS_BUY_US_PERSON,
    FUNDS_TRANSFER_US_PERSON,
    STOCKS_BUY_US_PERSON,
    ETFS_BUY_US_PERSON,
    BUILD_YOUR_PORTFOLIO_US_PERSON,
    WARRANTS_BUY_US_PERSON,
    RIGHTS_BUY_US_PERSON,
} = require("constants/flagBasedFeatures");

const {
    BROKER_CONVENIENCE_MIFID_ETF_BUY,
    BROKER_CONVENIENCE_MIFID_FUND_BUY,
    BROKER_CONVENIENCE_MIFID_STOCK_BUY,
    BROKER_CONVENIENCE_MIFID_TEST_INTERNAL_TRANSFER_FUND,
    BROKER_CONVENIENCE_MIFID_CM_BUY,
    BROKER_CONVENIENCE_MIFID_WARRANT_BUY,
    BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_RIGHTS_BUY,
} = require("constants/index")

const getUsPersonFeatureFlag = (operationType) => {
    switch (operationType) {
        case BROKER_CONVENIENCE_MIFID_FUND_BUY:
            return FUNDS_BUY_US_PERSON;
        case BROKER_CONVENIENCE_MIFID_TEST_INTERNAL_TRANSFER_FUND:
            return FUNDS_TRANSFER_US_PERSON;
        case BROKER_CONVENIENCE_MIFID_STOCK_BUY:
            return STOCKS_BUY_US_PERSON;
        case BROKER_CONVENIENCE_MIFID_ETF_BUY:
            return ETFS_BUY_US_PERSON;
        case BROKER_CONVENIENCE_MIFID_CM_BUY:
            return BUILD_YOUR_PORTFOLIO_US_PERSON;
        case BROKER_CONVENIENCE_MIFID_WARRANT_BUY:
            return WARRANTS_BUY_US_PERSON;
        case BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_RIGHTS_BUY:
            return RIGHTS_BUY_US_PERSON;
        default:
            return null;
    }
}

module.exports = {
    getUsPersonFeatureFlag,
};